<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
    class="m-edition-section-content-subject"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingInvoice"
    class="m-edition-section-content-subject"
  >
    <form @submit.prevent="downloadInvoicePdf">
      <div
        class="align-items-flex-end display-flex-row"
      >
        <AtomButtonPrimary
          :button-primary="buttonPrimary.download"
          :disabled="!canDownloadInvoicePdf"
        />
      </div>
    </form>

    <!-- TODO: crear comprobante que solo contenga el comprobante para que sea utilizado en más de una molécula -->
    <div class="comprobante">
      <div class="comprobante-header">
        <div
          v-if="comprobante.ruta_logo"
          class="comprobante-header-logo"
        >
          <img :src="comprobante.ruta_logo" alt="">
        </div>
        <div
          v-else
          class="comprobante-header-logo"
        >
        </div>
        <div class="comprobante-header-data-empresa">
          <ul>
            <li><span class="font-weight-regular">{{ comprobante.emisor.razon_social }}</span></li>
            <li><span>{{ comprobante.emisor.documento.tipo }}: {{ comprobante.emisor.documento.numero }}</span></li>
            <li><span>{{ comprobante.emisor.domicilio.linea1 }}</span></li>
            <li v-if="comprobante.emisor.domicilio.linea2"><span>{{ comprobante.emisor.domicilio.linea2 }}</span></li>
            <li><span>{{ comprobante.emisor.domicilio.provincia }}, {{ comprobante.emisor.domicilio.pais }}</span></li>
            <li v-if="comprobante.emisor.telefono"><span>Teléfono: {{ this.comprobante.emisor.telefono }}</span></li>
            <li v-if="comprobante.emisor.movil"><span>Móvil: {{ comprobante.emisor.movil }}</span></li>
          </ul>
        </div>
        <div class="comprobante-header-data-numeracion">
          <ul>
            <li v-if="comprobante.tipo"><span class="data-name">Nº {{ comprobante.tipo.nombre }}:</span>
              <span
                v-if="comprobante.numero"
                class="data-value"
              >
                {{ comprobante.numero }}
              </span>
              <span
                v-else
                class="data-value"
              >
                -
              </span>
            </li>
            <li v-if="comprobante.fecha"><span class="data-name">Fecha Pago:</span>
              <span v-if="comprobante.numero" class="data-value">{{ $moment.parseZone(comprobante.fecha).format('DD/MM/YYYY') }}</span>
              <span v-else class="data-value"> - </span>
            </li>
            <li v-if="comprobante.fecha_autorizacion"><span class="data-name">Fecha Emisión:</span>
              <span v-if="comprobante.numero" class="data-value">{{ $moment.parseZone(comprobante.fecha_autorizacion).format('DD/MM/YYYY') }}</span>
              <span v-else class="data-value"> - </span>
            </li>
            <li v-if="comprobante.medio_pago"><span class="data-name">Medio de Pago:</span> <span class="data-value">{{ comprobante.medio_pago }}</span></li>
            <li v-if="comprobante.pago_estado">
              <span class="data-name">
                Estado:
              </span>
              <span class="data-value">
                {{ comprobante.pago_estado === 'Pendiente' ? 'En Proceso' : comprobante.pago_estado }}
              </span>
            </li>
            <li v-if="comprobante.anula"><span class="data-name">Anula:</span> <span class="data-value">{{ comprobante.anula.numero }}</span></li>
<!--            <li v-if="comprobante.id_externo"><span class="data-name">CAE:</span> <span class="data-value">{{ comprobante.id_externo }}</span></li>-->
          </ul>
        </div>
        <div v-if="comprobante.metadata" class="comprobante-header-data-qr">
          <div v-if="comprobante.metadata.qr && comprobante.estado.estado === 2">
            <a :href="comprobante.metadata.url" target="_blank" rel="noopener noreferrer">
              <img
                :src="`data:image/png;base64,${comprobante.metadata.qr}`"
                alt="QR Code"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="comprobante-data-cliente">
        <div class="comprobante-data-cliente-titulo">
          <h2>Cliente</h2>
        </div>
        <div class="comprobante-data-cliente-setizq">
          <ul>
            <li v-if="comprobante.receptor.documento">
              <span
                v-if="comprobante.receptor.documento.tipo"
                class="data-name">
                  {{ comprobante.receptor.documento.tipo }}:
              </span>
              <span
                v-if="comprobante.receptor.documento.numero"
                class="data-value">
                {{ comprobante.receptor.documento.numero }}
              </span>
            </li>
            <li v-if="comprobante.receptor">
              <span class="data-name">
                Cliente:
              </span>
              <span
                v-if="comprobante.receptor.razon_social"
                class="data-value">
                  {{ comprobante.receptor.razon_social }}
              </span>
              <span
                v-else
                class="data-value">
                  -
              </span>
            </li>
            <li v-if="comprobante.receptor.domicilio.linea1">
              <span class="data-name">Dirección:</span>
              <span class="data-value">
                {{ comprobante.receptor.domicilio.linea1.toLowerCase() }}
              </span>
            </li>
            <li v-if="comprobante.receptor.domicilio.linea2">
              <span class="data-name"></span>
              <span class="data-value">
                {{ comprobante.receptor.domicilio.linea2 }}
              </span>
            </li>
            <li v-if="comprobante.receptor.domicilio.codigo_postal">
              <span class="data-name">
                Código Postal:
              </span>
              <span class="data-value">
                  {{ comprobante.receptor.domicilio.codigo_postal }}
              </span>
            </li>
            <li v-if="comprobante.receptor">
              <span class="data-name">
                E-mail:
              </span>
              <span
                v-if="comprobante.receptor.email"
                class="data-value">
                  {{ comprobante.receptor.email}}
              </span>
              <span
                v-else
                class="data-value">
                  -
              </span>
            </li>
          </ul>
        </div>
        <div
          v-if="comprobante.receptor"
          class="comprobante-data-cliente-setder">
          <ul>
            <li v-if="comprobante.receptor.domicilio.pais">
              <span class="data-name">
                  País:
              </span>
              <span class="data-value">
                  {{ comprobante.receptor.domicilio.pais }}
              </span>
            </li>
            <li  v-if="comprobante.receptor.domicilio.provincia">
              <span class="data-name">
                Provincia:
              </span>
              <span class="data-value">
                {{ comprobante.receptor.domicilio.provincia }}
              </span>
            </li>
            <li v-if="comprobante.receptor.domicilio.localidad">
              <span class="data-name">
                Localidad:
              </span>
              <span class="data-value">
                  {{ comprobante.receptor.domicilio.localidad }}
              </span>
            </li>
            <li v-if="comprobante.receptor.telefono">
              <span class="data-name">
                Teléfono:
              </span>
              <span class="data-value">
                  {{ comprobante.receptor.telefono }}
              </span>
            </li>
            <li v-if="comprobante.receptor.movil">
              <span class="data-name">
                Móvil:
              </span>
              <span class="data-value">
                {{ comprobante.receptor.movil }}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="comprobante-data-items">
        <table>
          <tr>
            <th width="35%" class="text-align-left">ITEM</th>
            <th width="30%" class="text-align-right">PRECIO UNITARIO</th>
            <th width="15%" class="text-align-center">UNIDADES</th>
            <th width="20%" class="text-align-right">SUBTOTAL</th>
          </tr>
          <tr>
            <td
              v-if="comprobante.detalle"
              class="text-align-left"
            >
              {{ comprobante.detalle }}
            </td>
            <td
              v-else
              class="text-align-left"
            >
              No fue posible encontrar el detalle del pago
            </td>
            <td
              v-if="comprobante.neto"
              class="text-align-right"
            >
              {{ ` ${comprobante.divisa_simbolo} ${(comprobante.neto * 1).toFixed(2)} ${comprobante.divisa}` }}
            </td>
            <td
              v-else
              class="text-align-right"
            >
              {{ ` ${comprobante.divisa_simbolo} ${(comprobante.total * 1).toFixed(2)} ${comprobante.divisa}` }}
            </td>
            <td
              v-if="comprobante.unidades"
              class="text-align-center"
            >
              {{ comprobante.unidades }}
            </td>
            <td class="text-align-center">1</td>
            <td class="text-align-right">{{ `${comprobante.divisa_simbolo} ${(comprobante.neto ? comprobante.neto * 1 : comprobante.total * 1).toFixed(2)} ${comprobante.divisa}` }}</td>
          </tr>
          <tr v-if="comprobante.cotizacion">
            <td class="text-align-left">
              <i class="font-size-small font-weight-light">Cotización 1 {{ comprobante.divisa_original }} - {{ comprobante.cotizacion }} {{ comprobante.divisa }}</i>
            </td>
          </tr>
        </table>
      </div>
      <div class="comprobante-data-total">
        <table>
          <tr>
            <td width="80%" class="text-align-right">Subtotal</td>
            <td width="20%" class="text-align-right">{{ `${comprobante.divisa_simbolo} ${(comprobante.neto ? comprobante.neto * 1: comprobante.total * 1).toFixed(2)} ${comprobante.divisa}` }}</td>
          </tr>
          <tr>
            <td width="80%" class="text-align-right">Impuestos (IVA) {{ comprobante.impuesto }}%</td>
            <td width="20%" class="text-align-right">
              <span  v-if="comprobante.impuesto">
                {{ ` ${comprobante.divisa_simbolo} ${(comprobante.monto_impuesto * 1).toFixed(2)} ${comprobante.divisa}` }}
              </span>
              <span v-else>
                {{ ` ${comprobante.divisa_simbolo} ${(0 * 1).toFixed(2)} ${comprobante.divisa}` }}
              </span>
            </td>
          </tr>
          <tr>
            <td width="80%" class="text-align-right font-weight-bold">Total</td>
            <td
              v-if="comprobante.total"
              width="20%" class="text-align-right font-weight-bold"
            >
              {{ ` ${comprobante.divisa_simbolo} ${(comprobante.total * 1).toFixed(2)} ${comprobante.divisa}` }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- fin comprobante -->
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsInvoice',

  data () {
    return {
      buttonSecondary: {
        refund: {
          class: 'a-button-academy-secondary',
          component: '',
          icon: 'fas fa-undo-alt',
          method: '',
          text: 'Reembolsar',
          type: 'button'
        },

        print: {
          class: 'a-button-academy-secondary a-button-side',
          component: '',
          icon: 'fas fa-print',
          method: 'print',
          text: 'Imprimir',
          type: 'button'
        },

        send: {
          class: 'a-button-academy-secondary a-button-side',
          component: '',
          icon: 'fas fa-envelope',
          method: '',
          text: 'Enviar por e-mail',
          type: 'button'
        }
      },

      buttonPrimary: {
        download: {
          action: 'Descargar PDF',
          class: 'a-button-academy-primary margin-left-auto',
          sending: false,
          type: 'submit'
        }
      },

      comprobante: null,

      showLoadingState: false
    }
  },

  created () {
    this.readInvoiceData()
  },

  computed: {
    canDownloadInvoicePdf () {
      if (!this.comprobante || !this.comprobante.estado) {
        return false
      }

      const estado = this.comprobante.estado.estado

      // 2: autorizado | 1: en proceso, sin autorizador fiscal se autoriza manualmente
      return estado === 2 || (!this.comprobante.autorizador_fiscal && estado === 1)
    }
  },

  methods: {
    downloadInvoicePdf () {
      if (this.canDownloadInvoicePdf && !this.buttonPrimary.download.sending) {
        this.buttonPrimary.download.sending = true

        this.$services.read('comprobante', 'readComprobantePdf', { responseType: 'blob' }, [this.$route.params.thirdid])
          .then(response => {
            const contentDisposition = response.headers && response.headers['content-disposition']
            const utf8FileNameMatch = contentDisposition && contentDisposition.match(/filename\*=UTF-8''([^;\n]+)/i)
            const basicFileNameMatch = contentDisposition && contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            const fileName = utf8FileNameMatch && utf8FileNameMatch[1]
              ? decodeURIComponent(utf8FileNameMatch[1])
              : (basicFileNameMatch && basicFileNameMatch[1]
                ? basicFileNameMatch[1].replace(/['"]/g, '')
                : null)
            const pdfBlob = response.data instanceof Blob
              ? response.data
              : new Blob([response.data], { type: 'application/pdf' })
            const pdfUrl = window.URL.createObjectURL(pdfBlob)
            const downloadLink = document.createElement('a')

            downloadLink.href = pdfUrl
            downloadLink.setAttribute('download', fileName || `${this.$route.params.thirdid}.pdf`)
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(pdfUrl)
            this.buttonPrimary.download.sending = false
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.download.sending = false
            this.showLoadingState++
          })
      }
    },

    readInvoiceData () {
      this.$services.read('comprobante', 'readComprobante', {}, [this.$route.params.subid])
        .then(response => {
          console.log(response.data)
          this.comprobante = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
